import React from 'react';
import { BackNavigation } from '../../components';
import css from './ListingPage.module.css';

const ListingBackLink = ({ location, fallback = { pathname: '/s' }, fallbackLabel = 'Back to Marketplace' }) => {
  const origin = location?.state?.from;
  const destination = origin?.pathname ? origin : fallback;
  const label = location?.state?.backLabel || fallbackLabel;

  return <BackNavigation className={css.listingBackNavigation} to={destination} label={label} />;
};

export default ListingBackLink;
